import { SERVER } from "./config";

export enum TagType {
  Auth = "Auth",
  Restaurant = "Restaurant",
  Item = "Item",
  Admin = "Admin",
  City = "City",
  ModifierOption = "ModifierOption",
  ModifierGroup = "ModifierGroup",
  Header = "Header",
  Rider = "Rider",
  Order = "Order",
  RiderRequest = "RiderRequest",
  RestaurantRequest = "RestaurantRequest",
  Ad = "Ad",
}

export const TagId = {
  LIST: "LIST",
  ALL_LIST: "ALL_LIST",
  RUSH_COUNT: "RUSH_COUNT", // exclusive only to orders
} as const;

export type TagIdType = (typeof TagId)[keyof typeof TagId];

const APIS = {
  AUTH: {
    reducerPath: "auth",
    baseUrl: SERVER.URL + "/auth",
    tagTypes: [TagType.Auth],
  },
  RESTAURANT: {
    reducerPath: "restaurant",
    baseUrl: SERVER.URL + "/restaurants",
    tagTypes: [TagType.Restaurant],
  },
  ITEM: {
    reducerPath: "items",
    baseUrl: SERVER.URL + "/items",
    tagTypes: [TagType.Item],
  },
  ADMIN: {
    reducerPath: "admins",
    baseUrl: SERVER.URL + "/admins",
    tagTypes: [TagType.Admin],
  },
  MODIFIER_OPTION: {
    reducerPath: "modifierOptions",
    baseUrl: SERVER.URL + "/modifier-options",
    tagTypes: [TagType.ModifierOption],
  },
  MODIFIER_GROUP: {
    reducerPath: "modifierGroups",
    baseUrl: SERVER.URL + "/modifier-groups",
    tagTypes: [TagType.ModifierGroup],
  },
  CITY: {
    reducerPath: "cities",
    baseUrl: SERVER.URL + "/cities",
    tagTypes: [TagType.City],
  },
  HEADER: {
    reducerPath: "headers",
    baseUrl: SERVER.URL + "/headers",
    tagTypes: [TagType.Header],
  },
  RIDER: {
    reducerPath: "riders",
    baseUrl: SERVER.URL + "/riders",
    tagTypes: [TagType.Rider],
  },
  ORDER: {
    reducerPath: "orders",
    baseUrl: SERVER.URL + "/orders",
    tagTypes: [TagType.Order],
  },
  RIDER_REQUEST: {
    reducerPath: "riderRequests",
    baseUrl: SERVER.URL + "/rider-requests",
    tagTypes: [TagType.RestaurantRequest],
  },
  RESTAURANT_REQUEST: {
    reducerPath: "restaurantRequests",
    baseUrl: SERVER.URL + "/restaurant-requests",
    tagTypes: [TagType.RestaurantRequest],
  },
  AD: {
    reducerPath: "ads",
    baseUrl: SERVER.URL + "/ads",
    tagTypes: [TagType.Ad],
  },
};

export const {
  AUTH,
  RESTAURANT,
  ITEM,
  ADMIN,
  CITY,
  MODIFIER_OPTION,
  MODIFIER_GROUP,
  HEADER,
  RIDER,
  ORDER,
  RIDER_REQUEST,
  RESTAURANT_REQUEST,
  AD,
} = APIS;
